<mojo-mft-preview-mode-dialog
  [showDialog]="showDialog"
  [tenants]="tenants | async"
  [tenantParents]="tenantParents | async"
  [users]="users | async"
  (onOk)="onOk($event)"
  (onCancel)="onCancel()"
  >
</mojo-mft-preview-mode-dialog>
